import React from 'react'
import { Navigate } from 'react-router-dom'
import { usePartnerAuth } from '../context/PartnerAuthContext'

type RequirePartnerProps = {
  children: React.ReactNode
  requiredRole?: 'ADMIN_PARTNER' | 'USER_PARTNER'
}

/**
 * HOC pour protéger les routes partenaire
 * Redirige vers /partner/login si non authentifié ou si pas le rôle PARTNER
 */
const RequirePartner: React.FC<RequirePartnerProps> = ({ children, requiredRole }) => {
  const { isPartner, isAdminPartner, partnerProfile, loading } = usePartnerAuth()

  if (loading) {
    return (
      <div className="loading-container">
        <p>Chargement...</p>
      </div>
    )
  }

  // Si pas connecté en tant que partenaire, rediriger vers login
  if (!isPartner) {
    return <Navigate to="/partner/login" replace />
  }

  // Vérifier le rôle si spécifié
  if (requiredRole === 'ADMIN_PARTNER' && !isAdminPartner) {
    return (
      <div className="error-container">
        <h2>Accès refusé</h2>
        <p>Vous n'avez pas les permissions nécessaires pour accéder à cette page.</p>
        <p>Seuls les administrateurs partenaires peuvent accéder à cette section.</p>
      </div>
    )
  }

  return <>{children}</>
}

export default RequirePartner
